<template>
    <div class="relative">
        <a @click.prevent="isOpen = !isOpen" href="javascript:" id="cart" class="shoppingCart link">
            <img src="/images/icon-cart.png" alt="cart icon">
            <div class="count" v-text="currentProducts.length"></div>
            <span class="iconText">Winkelwagen</span>
        </a>

        <div class="shopping-cart" :style="{display: isOpen ? 'block' : 'none'}" v-if="isLoading === false">
            <div class="shopping-cart-header">
                <div class="shopping-cart-total fs14">
                    <span class="regularFont">{{ label('shop.cart.subtotal_incl') }}:</span>
                    <span class="main-color-text boldFont">{{ subTotal }}</span>
                </div>
            </div>
            <div class="shopping-cart-header mb10 mt10" v-if="discountAmount > 0">
                <div class="shopping-cart-total fs14">
                    <span class="regularFont">{{ label('shop.cart.discount') }}:</span>
                    <span class="main-color-text boldFont">-{{ discount }}</span>
                </div>
            </div>

            <ul class="shopping-cart-items" v-if="currentProducts.length > 0">
                <li class="clearfix dummy-hr borderBottom" v-for="product in currentProducts">
                    <div class="shopping-cart-image image">
                        <img src="/images/thema_stapelkorting_klein.png" alt="stapelkorting" class="stapelkorting" v-if="product.bulk_discount" />
                        <img :src="product.thumbnail" :alt="product.name">
                    </div>
                    <div class="shopping-cart-info">
                        <a :href="'/' + product.url" class="item-name boldFont line14 blackColor" v-text="product.name"></a>
                        <div>
                            <span class="item-price">{{ formatPrice(product.linePriceIncl) }}</span>
                            <span class="item-quantity">{{ label('shop.cart.quantity') }}: {{ product.amount }}</span>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="fs12 text-dark mt20 mb20 text-center line14" v-else style="float: left;">
                {{ label('shop.cart.no_products_added') }}
            </div>

            <div class="">
                <a :href="cartUrl" class="button blue centerText small mt5 w100p">
                    {{ label('shop.cart.show_cart') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import translations from "../mixins/translations";

export default {
    name: "header-cart",
    mixins: [translations,],
    components: {},
    props: {
        cartUrl: {
            required: true,
            type: String
        },
        currency: {
            required: false,
            type: String,
            default: "EUR"
        }
    },
    data: function () {
        return {
            product_counter: 0,
            isOpen: false
        }
    },
    methods: {
        formatPrice(amount) {
            return this.$root.formatPrice(amount, this.currency, true);
        }
    },
    computed: {
        isLoading() {
            return !this.cart;
        },
        cart() {
            return this.$store.state.cart.cart;
        },
        currentTotal() {
            if (this.cart) {
                return this.cart.totalPriceIncl;
            }
            return 0;
        },
        discountAmount() {
            if (this.cart) {
                return this.cart.discountAmount;
            }
            return 0;
        },
        bulkDiscountAmount() {
            if (this.cart) {
                return this.cart.bulkDiscountAmount;
            }
            return 0;
        },
        totalPrice() {
            return this.$root.formatPrice(this.currentTotal, this.currency, true);
        },
        subTotal() {
            if (this.cart) {
                return this.$root.formatPrice(this.cart.subTotalPrice, this.currency, true);
            }
            return '?';
        },
        discount() {
            return this.$root.formatPrice(this.discountAmount, this.currency, true);
        },
        currentProducts() {
            return this.$store.state.cart.cartItems;
        }
    },
    watch: {},
    mounted() {
    },
    created() {
    }

}
</script>

<style scoped>
.dummy-hr:after {
    display: inline-block;
    border: 0;
    width: 100%;
    height: 1px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.dummy-hr:last-of-type:after {
    margin-top: inherit;
    margin-bottom: inherit;
    border: 0;
}
</style>
